import styles from './Carregamento.module.scss';

export const Carregamento = () => {
  return (
    <div className={styles.page}>
      <div className={styles.loadingContainer}>
        <img className={styles.logoEmpresa} src='/imagens/logo.png' alt="Logo" />
        <div className={styles.loadingSpinner}></div>
        <div className={styles.loadingWord}>CARREGANDO...</div>
      </div>
    </div>
  );
};